import { useState, useRef } from 'react';

function Card({ title, description, onClick, }) {
    return (React.createElement("div", { className: "tw:max-w-72 tw:rounded-xl tw:border tw:border-gray-200 tw:bg-white tw:shadow-sm tw:p-4 hover:tw:shadow-lg hover:tw:border-gray-300 tw:transition-all tw:duration-200 tw:cursor-pointer tw:text-left", onClick: onClick },
        React.createElement("div", { className: "tw:space-y-2" },
            React.createElement("h4", { className: "tw:text-sm tw:font-semibold tw:text-gray-900 tw:leading-tight" }, title),
            React.createElement("p", { className: "tw:text-sm tw:text-gray-600 tw:leading-relaxed" }, description))));
}
const AnimatedMasonryGrid = ({ items, onItemClick, }) => {
    const [isPaused, setIsPaused] = useState(false);
    const containerRef = useRef(null);
    // Split items into 3 rows for masonry effect
    const rows = [
        items.filter((_, i) => i % 3 === 0),
        items.filter((_, i) => i % 3 === 1),
        items.filter((_, i) => i % 3 === 2),
    ];
    // Duplicate items for seamless loop
    const duplicatedRows = rows.map((row) => [...row, ...row]);
    return (React.createElement("div", { ref: containerRef, style: {
            width: "100%",
            overflow: "hidden",
            position: "relative",
            maskImage: "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
            WebkitMaskImage: "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
        }, onMouseEnter: () => setIsPaused(true), onMouseLeave: () => setIsPaused(false) },
        React.createElement("style", null, `
          @keyframes scroll-left {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }

          @keyframes scroll-right {
            0% {
              transform: translateX(-50%);
            }
            100% {
              transform: translateX(0);
            }
          }

          .animate-scroll-left {
            animation: scroll-left 40s linear infinite;
          }

          .animate-scroll-right {
            animation: scroll-right 45s linear infinite;
          }

          .paused {
            animation-play-state: paused !important;
          }
        `),
        React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: "12px" } }, duplicatedRows.map((row, rowIndex) => (React.createElement("div", { key: rowIndex, className: `${rowIndex % 2 === 0
                ? "animate-scroll-left"
                : "animate-scroll-right"} ${isPaused ? "paused" : ""}`, style: {
                display: "flex",
                gap: "8px",
                width: "max-content",
            } }, row.map((item, itemIndex) => (React.createElement(Card, { key: `${rowIndex}-${itemIndex}`, title: "Suggested search", description: item, onClick: () => onItemClick(item) })))))))));
};

export { AnimatedMasonryGrid, Card as default };
//# sourceMappingURL=AnimatedMasonryGrid.js.map
